import { ParameterTypeSelector } from "../ParameterTypeSelector";
import { ParametersPreviewSidebar } from "../ParametersPreviewSidebar";

import { BuilderContent } from "./BuilderContent";
import { Controls } from "./Controls";

export const ParameterBuilderDialog = ({
  onRequestClose,
  onSave,
}: {
  onRequestClose: () => void;
  onSave: () => void;
}) => (
  <div className="flex h-full min-h-0 gap-6 overflow-hidden">
    <div className="flex min-h-0 w-[60%] flex-col border-r pr-4">
      <h1 className="mb-4 shrink-0 text-lg font-medium">Add a new parameter</h1>
      <div className="flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto">
        <ParameterTypeSelector />
        <BuilderContent />
      </div>
      <div className="mt-4 flex shrink-0 gap-2 border-t pt-4">
        <Controls onRequestClose={onRequestClose} onSave={onSave} />
      </div>
    </div>
    <div className="flex min-h-0 w-[40%] flex-col overflow-hidden">
      <ParametersPreviewSidebar />
    </div>
  </div>
);
